<template>
    <div class="teacher-info">
        <div class="left">
            <TeacherDisplayboard :teacherInfo="teacherInfo"></TeacherDisplayboard>
        </div>
        <div class="right">
            <div class="info-head">
                <div>Tefl English teacher from Toronto university, and translator from Concordia university.</div>
                <div><i class="el-icon-location"></i>{{teacherInfo.address}}</div>
            </div>
            <div class="course-about">
                <div class="title-box">
                    <div class="main-title">About the lesson</div>
                    <div class="sub-title">My teaching methods vary according to my students,
                        but they all are dynamic, engaging and have a lot of fun.
                        My first class is to identify all the flaws a student or a group might have,
                        and from there I apply a teaching method with integrates the four pillars of a language which are listening,
                        writing, oral and grammar.
                    </div>
                </div>
                <el-scrollbar class="course-box">

                    <div class="class-item" v-for="item,index in teachersCourseList" :key="index">
                        <img class="course-img" :src="item.courseImg" />
                        <div style="color:#000;
                            padding:0 12px;
                            overflow-y: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;min-height: 48px;">
                            {{item.courseName}}
                        </div>
                        <div class="class-item-body">
                            <div class="info-stars">
                                <img :src="require('@/assets/icon/star.png')" />
                                <span>{{item.avgscore}}</span>
                                <span class="reviews">&nbsp; ({{item.viewtimes}} Reviews)</span>
                            </div>
                            <div class="course-price">C$ {{(item.price/100).toFixed(2)}}/h</div>
                            <div class="my-button" @click="gotoBookClass(item)"><span>Book a class</span></div>
                        </div>
                    </div>
                </el-scrollbar>
                <div class="title-box">
                    <div class="main-title">About {{teacherInfo.realname}}</div>
                    <div class="sub-title">{{teacherInfo.desc}}
                    </div>
                </div>
                <div class="title-box">
                    <div style="display: flex;justify-content: space-between;align-items: center;">
                        <div class="main-title">Review</div>
                        <div class="main-title-right">
                            <img :src="require('@/assets/icon/star.png')" />
                            <span>{{teacherInfo.avgscore}}({{teacherInfo.viewtimes}} Reviews)</span>
                        </div>
                    </div>
                </div>
                <Review></Review>
            </div>
        </div>
    </div>
</template>

<script>
import Review from './Review.vue'
import TeacherDisplayboard from './TeacherDisplayboard.vue'
export default {
    components: {
        Review,
        TeacherDisplayboard
    },
    mounted() {
        this.teacherId = this.$route.query.teacherId || '';
        this.getTeacherDetail();
        this.getCourseListbyTeachaer();
    },
    data() {
        return {
            rateValue: 3.7,
            teacherId: '',
            teacherInfo: {},
            teachersCourseList: []
        }
    },
    methods: {
        gotoBookClass(item) {
            this.$router.push({
                path: '/page/bookacourse',
                query: {
                    teacherId: item.teacherID,
                    courseId: item.id
                }
            })
        },
        getTeacherDetail() {
            this.$api.courseApi.getDetaiTeacher({ teacherId: this.teacherId }).then(res => {
                if (res.status === '0') {
                    this.teacherInfo = res.data;
                }
            })
        },
        getCourseListbyTeachaer() {
            this.$api.courseApi.getDetaiTeacherCourses({ teacherId: this.teacherId }).then(res => {
                if (res.status === '0') {
                    this.teachersCourseList = res.data.rows;
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.teacher-info {
    width: 100%;
    padding: vw(48) vw(170);
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    transition: 0.2s;
    .left {
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: vw(88);
        flex: 2.45;
        margin-right: vw(32);
        .course-evaluate {
            width: 100%;
            height: 96px;
            background: #ffffff;
            box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
            border-radius: 24px;
            margin-bottom: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
                line-height: 24px;
                font-size: 14px;
                color: #201002;
                margin: 0 4px;
            }
            .el-rate {
            }
        }
    }

    /deep/.info-stars {
        margin-top: 12px;
        font-size: 14px;
        line-height: 20px;
        img {
            width: 12px;
            height: 12px;
            margin-right: 4px;
        }
        .reviews {
            color: #a6a6a6;
        }
    }
    .right {
        // width: 75%;
        flex: 8;
        width: 0;
        .info-head {
            padding: vw(35) vw(37) vw(32) vw(32);
            box-sizing: border-box;
            background: rgba(252, 233, 209, 0.54);
            border-radius: 24px;

            font-weight: 600;
            color: #f48c06;
            div:nth-child(1) {
                font-size: 36px;
                line-height: 48px;
            }
            div:nth-child(2) {
                margin-top: 16px;
                line-height: 30px;
                font-size: 14px;
                i {
                    font-size: 20px;
                    margin-right: 8px;
                }
            }
        }
        .course-about {
            .title-box {
                color: #201002;
                margin-top: vw(48);
                .main-title {
                    font-weight: 600;
                    font-size: 24px;
                    line-height: 24px;
                }
                .sub-title {
                    margin-top: 16px;
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 30px;
                }
            }
            .main-title-right {
                box-sizing: border-box;
                padding: 6px 16px;
                height: 32px;
                background: rgba(252, 233, 209, 0.54);
                border-radius: 24px;
                display: flex;
                align-items: center;
                img {
                    margin-right: 4px;
                }
            }
            .course-box {
                display: flex;
                position: relative;
                margin-top: 24px;
                /deep/ .el-scrollbar__wrap {
                    width: 100%;
                    margin-bottom: 17px !important;
                    overflow: hidden !important;
                    .el-scrollbar__view {
                        display: -webkit-box;
                        -webkit-box-orient: horizontal;
                    }
                }
                .class-item:nth-child(n + 2) {
                    margin-left: 32px;
                }
                .class-item {
                    width: calc(25% - 24px);
                    // width: calc(33.33% - 21.33px);
                    background: #fff;
                    border-radius: 8px;
                    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
                    // margin-left: 32px;
                    .course-img {
                        width: 100%;
                        height: vw(180);
                        border-radius: 8px;
                    }
                    .class-item-body {
                        padding: 0 12px 24px;
                        box-sizing: border-box;
                        .course-price {
                            margin-top: 12px;
                            display: inline-block;
                            height: 32px;
                            background: rgba(252, 233, 209, 0.54);
                            border-radius: 24px;
                            padding: 4px 16px;
                            font-size: 14px;
                            line-height: 24px;
                            color: #f48c06;
                            font-weight: 500;
                            box-sizing: border-box;
                        }
                        .my-button {
                            cursor: pointer;
                            margin-top: 24px;
                            width: 100%;
                            height: 48px;
                            background: #f48c06;
                            border-radius: 24px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            span {
                                font-size: 14px;
                                color: #ffffff;
                                line-height: 20px;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>